module.exports = __webpack_public_path__ + "img/collection-weddingRingsRedgold@2x.b355424.jpg";